import { useEffect } from "react";
import { HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

/** FAQ georiferite (visibili + JSON-LD FAQPage). `jsonld=false` se la pagina lo include già nel proprio blocco. */
export const FaqGeo = ({ faq, titolo = "Domande frequenti", jsonld = true, testid = "faq-geo", className = "" }) => {
  useEffect(() => {
    if (!jsonld || !faq?.length) return;
    const s = document.createElement("script"); s.type = "application/ld+json"; s.id = `ld-${testid}`;
    s.text = JSON.stringify({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) });
    document.head.appendChild(s);
    return () => s.remove();
  }, [faq, jsonld, testid]);
  if (!faq?.length) return null;
  return (
    <section className={`px-6 sm:px-12 py-12 ${className}`} data-testid={testid}>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0070BA] flex items-center gap-2"><HelpCircle size={13} /> FAQ</p>
      <h2 className="font-heading text-base md:text-lg font-semibold text-slate-900 mt-1">{titolo}</h2>
      <Accordion type="single" collapsible className="mt-4 max-w-4xl">
        {faq.map((f, i) => (
          <AccordionItem key={i} value={`f${i}`} data-testid={`${testid}-item-${i}`}>
            <AccordionTrigger className="text-left text-sm sm:text-base font-semibold text-slate-900">{f.q}</AccordionTrigger>
            <AccordionContent className="text-sm text-slate-700 leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
